import useQueryParams from "../../customHooks/useQueryParams";
import { resolveVisibleActions } from "../../helpers/utils/resolveVisibleActions";
import ButtonCustom from "../Buttons/ButtomCustom";

const ACTION_BUTTONS_CONFIG = {
  create: context => `create_${context}`,
  preview: () => "preview",
  save: () => "save",
  save_send: () => "save_send",
  duplicate: () => "duplicate",
  reject: () => "reject",
  approve: () => "approve",
  publish: () => "publish",
  obsolete: () => "obsolete",
  downloadWord: () => "download_docx",
  downloadPDF: () => "download_pdf",
};

const ActionButtons = ({ actions = [], handlers = {}, context = "", status }) => {
  const params = useQueryParams();
  const historyScreen = params.get("idHistory");
  const isEdit = params.get("id");

  if (historyScreen) return null;

  const visibleActions = resolveVisibleActions(actions, isEdit, status, handlers, context === "document");
  
  return (
    <>
      {Object.keys(ACTION_BUTTONS_CONFIG).map(action => {
        const isVisible = visibleActions?.includes(action);
        if (!isVisible) return null;

        const handler = handlers[action];
        const getType = ACTION_BUTTONS_CONFIG[action];

        if (!handler) return null;

        return (
          <ButtonCustom
            key={action}
            type={getType(context)}
            onClick={handler}
          />
        );
      })}
    </>
  );
};

export default ActionButtons;
